import type { RefundChargeInputDto, RefundChargePreviewDto } from './dto/refund-charge.dto'
import { BaseService } from '../../infra/base.service'
import type { Charge } from './charge.entity'
import type { ChargesRepository } from './charges.repository'
import type { GetBoletoDto } from './get-boleto.dto'
import type { GetPixDto } from './get-pix.dto'
import type { SingleCharge } from './single-charge.dto'

export class ChargesService extends BaseService<Charge> {
    constructor(private rep: ChargesRepository) {
        super(rep)
    }

    // estorno e operacao de PARCELA: cancelar uma assinatura nao devolve dinheiro de nada
    async refundPreview(chargeId: string, amount?: number, invoiceId?: string): Promise<RefundChargePreviewDto> {
        return this.rep.refundPreview(chargeId, amount, invoiceId)
    }

    async refund(chargeId: string, dto: RefundChargeInputDto): Promise<RefundChargePreviewDto> {
        return this.rep.refund(chargeId, dto)
    }

    async void(chargeId: string) {
        return this.rep.void(chargeId)
    }

    async paid(chargeId: string) {
        return this.rep.paid(chargeId)
    }

    async getBoleto(chargeId: string, invoiceId: string = null): Promise<GetBoletoDto> {
        return this.rep.getBoleto(chargeId, invoiceId)
    }

    // devolve o QR Code válido da parcela. 'expired' indica que havia um e ele venceu.
    async getPix(chargeId: string): Promise<GetPixDto> {
        return this.rep.getPix(chargeId)
    }

    // consulta o gateway na hora. usar so quando ha alguem esperando na tela.
    async refreshPix(chargeId: string): Promise<GetPixDto> {
        return this.rep.refreshPix(chargeId)
    }

    async singleCharge(chargeId: string, method?: string): Promise<SingleCharge> {
        return this.rep.singleCharge(chargeId, method)
    }

    async retry(chargeId: string) {
        return await this.rep.retry(chargeId)
    }

    async gatewaySync(chargeId: string): Promise<SingleCharge> {
        return this.rep.gatewaySync(chargeId)
    }
}
